import React from 'react';
export function StorySection() {
  return <section className="py-14 relative" data-id="element-665">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-666">
        <div className="prose prose-invert prose-cyan max-w-none text-lg text-gray-300 space-y-6" data-id="element-667">
          <p className="text-2xl font-heading text-white mb-8 text-center" data-id="element-668">
            Dear Architect,
          </p>

          <p className="text-2xl font-bold text-white text-center mb-12" data-id="element-669">
            I remember the exact moment the office lights stayed off for me.
          </p>

          <p data-id="element-670">
            I was on a Zoom call with my manager, telling him I was leaving. He
            was confused. He looked at my performance metrics—which were higher
            than anyone else's—and then at my resignation letter.
          </p>

          <div className="my-10" data-id="element-671">
            <blockquote className="border-l-2 border-cyan-500 pl-6 py-4 bg-cyan-500/5 rounded-r-lg italic text-gray-200 text-xl m-0" data-id="element-672">
              "How? You're making more money working 4 hours a week than the
              firm pays you for 60. Are you just that good at ChatGPT?"
            </blockquote>
            <p className="text-sm text-gray-500 italic mt-3 ml-6" data-id="element-673">
              — My former manager's last question
            </p>
          </div>

          <p data-id="element-674">I told him he was wrong.</p>

          <p className="text-xl font-bold text-white my-8" data-id="element-675">
            It wasn't ChatGPT. It was Architecture.
          </p>

          <p data-id="element-676">
            While my colleagues were manually "prompting" blog posts,
            copying-and-pasting into Google Docs, and chasing clients for $50 an
            article…
          </p>

          <div className="my-8 p-6 border-l-4 border-cyan-400 bg-cyan-950/20 rounded-r-lg" data-id="element-677">
            <p className="text-xl font-bold text-white m-0" data-id="element-678">
              I was building a Ghost Factory.
            </p>
            <p className="text-xl font-bold text-cyan-400 mt-2 mb-0" data-id="element-679">
              A system designed to scale without me.
            </p>
          </div>

          <div className="my-12 p-8 border border-cyan-500/20 bg-dark-900 rounded-lg text-center shadow-[0_0_30px_rgba(0,240,255,0.05)]" data-id="element-680">
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-681">
              The "Prompt Engineer" is a Commodity.
            </h3>
            <h3 className="text-3xl font-bold text-cyan-400 text-glow" data-id="element-682">
              The "Architect" is ELITE.
            </h3>
          </div>

          <p data-id="element-683">
            If you are currently trying to make money by selling "AI Writing,"
            you are in a race to the bottom. You are competing against millions
            of overseas freelancers willing to work for $5/hour.
          </p>

          <p data-id="element-684">
            In 2026, the market value of "writing a blog post" has dropped to
            zero.
          </p>

          <p data-id="element-685">Nobody wants to buy prompts anymore. They want to buy OUTCOMES.</p>

          <p data-id="element-686">
            They want their time back. They want a system that identifies leads,
            creates tailored content across 5 platforms, and distributes it
            while the owner sleeps.
          </p>

          <p className="text-2xl font-bold text-white mt-12 text-center" data-id="element-687">
            That is why I created THE $10K AI CONTENT ENGINE.
          </p>
        </div>
      </div>
    </section>;
}